// eslint-disable-next-line import/no-anonymous-default-export
export default {
    CPF: 0,
    PERFIL: 1,
    NOME_USUARIO: 2
}